import React, { memo, useState } from 'react';
import Tab from 'components/_parts/atoms/tab';
import Member from 'components/company/revamp/parts/member';
import { useTranslation } from 'react-i18next';
import Setting from './parts/setting';
import tabLabel from './parts/tabLabel';

const Content = memo(({ type }) => {
  if (type === 0) {
    return (
      <Setting />
    );
  }
  return (
    <Member />
  );
});
function ContentRight() {
  const { t } = useTranslation();
  const { tabList } = tabLabel({ t });
  const [tab, setTab] = useState(0);
  return (
    <Content type={tab} />
  );
}

export default ContentRight;
